// Only a confirmed server response allows the form to be cleared.
export const persistShipping = async (request, onFailure) => {
  let result;
  try {
    result = await request();
  } catch (error) {
    onFailure(error);
    return null;
  }
  if (!result || result.err || result.status !== 'OK') {
    onFailure(result);
    return null;
  }
  return result;
};
